import students2021_all from "../static/students/2021/students2021_all.webp";
import students2020_all from "../static/students/2020/students2020_all.webp";
import students2019_all from "../static/students/2019/students2019_all.webp";
import students2018_all from "../static/students/2018/students2018_all.webp";
import students2017_all from "../static/students/2017/students2017_all.webp";
import students2016_all from "../static/students/2016/students2016_all.webp";
import students2015_all from "../static/students/2015/students2015_all.webp";
import students2014_all from "../static/students/2014/students2014_all.webp";
import students2013_all from "../static/students/2013/students2013_all.webp";
import students2023_all from "../static/students/2023/students2023_all.jpg";
import students2022_all from "../static/students/2022/students2022_all.jpg";
import image1 from "../static/location/image1.jpg";

import post2 from "../static/news/post2.webp"
import post3 from "../static/news/post3.webp"
import post4 from "../static/news/post4.jpeg"
import post5 from "../static/news/post5.webp"
import post6 from "../static/news/post6.webp"
import post7 from "../static/news/post7.webp"
import post8 from "../static/news/post8.webp"
import post9 from "../static/news/post9.webp"
import post10 from "../static/news/post10.webp"
import post11 from "../static/news/post11.webp"
import post12 from "../static/news/post12.webp"
export const news = [
    // {
    //     link: "/students/2023",
    //     image: students2023_all,
    //     date: '27 сент. 2023 г.',
    //     title: 'Выпускники 2023 года',
    //     brief: "Латыпова Алина - Казанский федеральный университет (лингвистика: перевод и переводоведение) Филиппов Альберт - Казанский государственный..."
    // },
    // {
    //     link: "/students/2022",
    //     image: students2022_all,
    //     date: '9 авг. 2022 г.',
    //     title: 'Выпускники 2022 года',
    //     brief: "Хуснутдинова Лия - Казанский государственный медицинский университет (лечебное дело) Абрамова Анастасия - Российский национальный..."
    // },
    {
        id: 12,
        link: "post/12",
        image: post12,
        date: ' 1 сен. 2025 г.',
        title: 'Новый филиал в Лаишево!',
        brief: ""
    },
    {
        id: 11,
        link: "post/11",
        image: post11,
        date: ' 28 авг. 2022 г.',
        title: 'ЕГЭ 2022 - результаты',
        brief: "Русский язык сдавали 40 учеников. Наивысший балл - 100!!! Средний балл - 80.  Результат 94 балла и более показали 12 человек!..."
    },
    {
        link: "/students/2021",
        image: students2021_all,
        date: '3 янв. 2022 г.',
        title: 'Выпускники 2021 года',
        brief: "Елкина Дарина — Первый Московский государственный медицинский университет имени И. М. Сеченова (педиатрия) Хабибуллин Артём — Российский..."
    },
    {
        id: 10,
        link: "post/10",
        image: post10,
        date: '18 февр. 2021 г.',
        title: 'Обучение РКИ',
        brief: "Информационное письмо \"Гильдия репетиторов ТРИУМФ\" объявляет о наборе иностранных граждан для изучения русского языка..."
    },
    {
        link: "/students/2020",
        image: students2020_all,
        date: '14 сент. 2020 г.',
        title: 'Выпускники 2020 года',
        brief: "Шинкарёв Игорь - Национальный исследовательский технологический университет «МИСиС», г.Москва (прикладная информатика)..."
    },
    {
        id: 9,
        link: "post/9",
        image: post9,
        date: '18 авг. 2020 г.',
        title: 'ЕГЭ 2020 - результаты',
        brief: "Озвучим результаты ЕГЭ 2020. Русский язык - 25 учеников: 6 из них набрали от 90 до 100 баллов, 5 - от 80 до 89 баллов, 9 - от 70 до 79..."
    },
    {
        id: 8,
        link: "post/8",
        image: post8,
        date: '20 апр. 2020 г.',
        title: 'Издание сборника вариантов ЕГЭ',
        brief: "В апреле 2020 года Феоктистова Т.В. и Фахрутдинова М.Т. , преподаватели русского языка, издали сборник типовых экзаменационных..."
    },
    {
        id: 7,
        link: "post/7",
        image: post7,
        date: '17 февр. 2020 г.',
        title: 'Всероссийская научно-практическая конференция в КГМУ',
        brief: "Ученики \"Гильдии репетиторов ТРИУМФ\" стали участниками Всероссийской научно-практической конференции \"Национальный язык и культура в..."
    },
    {
        id: 6,
        link: "post/6",
        image: post6,
        date: '2 янв. 2020 г.',
        title: 'Консультация по профориентации',
        brief: "Календарный год в «Гильдии репетиторов ТРИУМФ» завершился консультацией по профориентации для учащихся 9-ых классов, которую в очередной..."
    },
    {
        id: 5,
        link: "post/5",
        image: post5,
        date: '17 дек. 2019 г.',
        title: 'Консультация по вопросам поступления в вузы РФ',
        brief: "В «Гильдии репетиторов ТРИУМФ» прошла серия консультаций по вопросам поступления в вузы России и выбору специальности. Перед..."
    },
    {
        id: 4,
        link: "post/4",
        image: post4,
        date: '28 нояб. 2019 г.',
        title: 'Итоговое сочинение 2019',
        brief: "(учебный материал для участников от экспертов ФИПИ)"
    },
    {
        id: 3,
        link: "post/3",
        image: post3,
        date: '10 сент. 2019 г.',
        title: 'Объявление о наборе',
        brief: "Дорогие ребята и уважаемые родители! «Гильдия репетиторов ТРИУМФ» объявляет о наборе в группы по подготовке к ОГЭ и ЕГЭ на 2019-2020..."
    },
    {
        id: 2,
        link: "post/2",
        image: post2,
        date: '5 сент. 2019 г.',
        title: 'ЕГЭ 2019 — результаты',
        brief: "Наконец-то мы дождались результатов ЕГЭ! Вот это урожай!!! Русский язык — 16 учеников: 4 (!!!) ученика получили 98 баллов, 2 — 96, 2 —..."
    },
    {
        id: 1,
        link: "post/1",
        image: image1,
        date: ' 2 сент. 2019 г.',
        title: 'Мы по новому адресу',
        brief: "Гильдия репетиторов «Триумф» переехала на ул. Жуковского, дом 8, офис 315"
    },
    {
        link: "/students/2019",
        image: students2019_all,
        date: '10 авг. 2019 г.',
        title: 'Выпускники 2019 года',
        brief: "Исмаилова Алавия - Rotterdam University of Applied Sciences (международный бизнес и менеджмент) Мухаметзянова Ралина..."
    },
    {
        link: "/students/2018",
        image: students2018_all,
        date: '30 окт. 2018 г.',
        title: 'Выпускники 2018 года',
        brief: "Исхаков Артём — Санкт-Петербургский горный университет (радиоэлектронные системы и комплексы) Хафизов Равиль — Казанский..."
    },
    {
        link: "/students/2017",
        image: students2017_all,
        date: '30 окт. 2017 г.',
        title: 'Выпускники 2017 года',
        brief: "Васильева Арина — Московский государственный университет (юридический факультет): русский язык — 88б., обществознание — 88б..."
    },
    {
        link: "/students/2016",
        image: students2016_all,
        date: '30 окт. 2016 г',
        title: 'Выпускники 2016 года',
        brief: "Бердников Андрей — Казанский (Поволжский) федеральный университет (информационные системы и технологии) Котов Виталий...."
    },
    {
        link: "/students/2015",
        image: students2015_all,
        date: '30 окт. 2015 г',
        title: 'Выпускники 2015 года',
        brief: "Копунов Михаил — Казанский национальный исследовательский технический университет Аласгарли Сеймур — Казанский национальный исследовательский..."
    },
    {
        link: "/students/2014",
        image: students2014_all,
        date: '30 окт. 2014 г',
        title: 'Выпускники 2014 года',
        brief: "Майорова Настя  а) Казанское художественное училище им. Фешина, отделение живописи; б) Казанский государственный университет культуры и искусств, специальность..."
    },
    {
        link: "/students/2013",
        image: students2013_all,
        date: '30 окт. 2013 г',
        title: 'Выпускники 2012-2013 годов',
        brief: "Ишмухаметов Байтазар Русский язык — 79 баллов; физика — 62 балла.  МИЭМ НИУ ВШЭ (Московский Институт Электроники и Математики Национального Исследовательского..."
    },
]